import { SummitIdObject } from '@summit/models';

export abstract class EboObject extends SummitIdObject {
  override id: string;

  constructor(jsonData?: Partial<EboObject>) {
    super(jsonData);
  }
}
